/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */
/**
 * @module typing
 */
export { default as Typing } from './typing.js';
export { default as Input } from './input.js';
export { default as Delete } from './delete.js';
export { default as TextWatcher } from './textwatcher.js';
export { default as TwoStepCaretMovement } from './twostepcaretmovement.js';
export { default as TextTransformation } from './texttransformation.js';
export { default as inlineHighlight } from './utils/inlinehighlight.js';
export { default as findAttributeRange, findAttributeRangeBound } from './utils/findattributerange.js';
export { default as getLastTextLine } from './utils/getlasttextline.js';
export { default as InsertTextCommand } from './inserttextcommand.js';
import './augmentation.js';
